import React from 'react';
import './App.css';
import PathfindingVisualizer from './PathFindingVisualizer/PathfindingVisualizer';

function App() {
  return (
    <div className="App">
      <PathfindingVisualizer />
    </div>
  );
}

export default App;